/**
 * Zeigt den Aufpreis an jeder Variantenoption — fest gegen die günstigste
 * Option der jeweiligen Gruppe (seit 09.10.2026; vorher gegen die aktuelle
 * Auswahl, was bei gewählter Aufpreis-Option „inklusive“ und Minusbeträge zeigte).
 *
 * Warum: Optionswerte wie "Mit"/"Ohne" kommen in mehreren Optionsgruppen
 * vor, und Preisaufschläge unterscheiden sich je nach Kombination
 * (z. B. kostet "befüllen lassen" nur zusammen mit Thermoflüssigkeit).
 * Ein statischer Wert wäre falsch, sobald der Kunde umschaltet.
 *
 * Vorgehen je Neuberechnung:
 *  1. Fieldsets den Optionspositionen zuordnen (über die Wertemengen,
 *     nicht über den Text — der ist mehrdeutig).
 *  2. Aktuelle Auswahl aus den checked-Inputs lesen.
 *  3. Für jede Option: Kandidat = Auswahl mit diesem einen Wert getauscht.
 *     Preisdifferenz zum aktuellen Preis anzeigen. Existiert die
 *     Kombination nicht, bleibt die Zeile ohne Preis.
 *
 * Die Daten kommen aus einem JSON-Block, den blocks/varianten-aufpreis.liquid
 * rendert. Fällt das Skript aus, bleibt der Picker unverändert nutzbar.
 */
(function () {
  'use strict';

  var geld = new Intl.NumberFormat('de-DE', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2,
  });

  function normal(s) {
    return String(s || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '');
  }

  function konfiguration() {
    var el = document.querySelector('[data-varianten-aufpreis]');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent);
      return d && d.varianten && d.varianten.length ? d : null;
    } catch (e) {
      return null;
    }
  }

  /** Beschriftung ohne bereits ergänzte Zusätze */
  function beschriftung(el) {
    var klon = el.cloneNode(true);
    [].forEach.call(klon.querySelectorAll('.va-preis, .vl-watt'), function (x) { x.remove(); });
    return (klon.textContent || '').replace(/\s+/g, ' ').trim();
  }

  var GROESSE = /^\d{2,3}x\d{2,3}$/;

  /** Wie viele Optionspositionen nutzt das Produkt? */
  function positionen(varianten) {
    var n = 0;
    [1, 2, 3].forEach(function (p) { if (varianten[0]['o' + p]) n = p; });
    return n;
  }

  /**
   * Fieldsets des Pickers einsammeln und je Fieldset die Optionsposition
   * bestimmen: die Position, deren Wertemenge die Button-Texte am besten
   * abdeckt. Jede Position wird nur einmal vergeben.
   */
  function fieldsetZuordnung(varianten) {
    var anz = positionen(varianten);
    var mengen = {};
    for (var p = 1; p <= anz; p++) {
      mengen[p] = {};
      varianten.forEach(function (v) { mengen[p][normal(v['o' + p])] = true; });
    }

    var fieldsets = [].filter.call(document.querySelectorAll('fieldset'), function (fs) {
      return fs.querySelector('label input[type="radio"], label[data-option-value]');
    });

    var kandidaten = [];
    fieldsets.forEach(function (fs) {
      var labels = [].slice.call(fs.querySelectorAll('label'));
      if (!labels.length) return;
      var texte = labels.map(function (l) { return normal(beschriftung(l)); }).filter(Boolean);
      if (!texte.length) return;
      for (var p = 1; p <= anz; p++) {
        var treffer = texte.filter(function (t) { return mengen[p][t]; }).length;
        kandidaten.push({ fs: fs, labels: labels, texte: texte, pos: p, quote: treffer / texte.length });
      }
    });

    // Beste Quoten zuerst, jede Position und jedes Fieldset nur einmal
    kandidaten.sort(function (a, b) { return b.quote - a.quote; });
    var posVergeben = {}, fsVergeben = new Set(), ergebnis = [];
    kandidaten.forEach(function (k) {
      if (k.quote < 0.5) return;
      if (posVergeben[k.pos] || fsVergeben.has(k.fs)) return;
      posVergeben[k.pos] = true;
      fsVergeben.add(k.fs);
      ergebnis.push(k);
    });
    return ergebnis;
  }

  /** Variante zu einer vollständigen Wertekombination finden */
  function varianteZu(varianten, werte) {
    for (var i = 0; i < varianten.length; i++) {
      var v = varianten[i], passt = true;
      for (var p = 1; p <= 3; p++) {
        if (werte[p] === undefined) continue;
        if (normal(v['o' + p]) !== werte[p]) { passt = false; break; }
      }
      if (passt) return v;
    }
    return null;
  }

  function anwenden() {
    var cfg = konfiguration();
    if (!cfg) return;

    var zuordnung = fieldsetZuordnung(cfg.varianten);
    if (!zuordnung.length) return;

    // Aktuelle Auswahl je Position
    var auswahl = {};
    zuordnung.forEach(function (z) {
      var checked = z.fs.querySelector('input:checked');
      var label = checked ? checked.closest('label') : null;
      if (label) auswahl[z.pos] = normal(beschriftung(label));
    });

    var aktuelle = varianteZu(cfg.varianten, auswahl);

    zuordnung.forEach(function (z) {
      var istGroesse = z.texte.every(function (t) { return GROESSE.test(t) || /^\d{2,3}$/.test(t); });
      if (istGroesse) {
        z.fs.classList.add('vl-groesse');
        // Größen tragen die Wattzahl — Preis dort würde den Button überladen
        [].forEach.call(z.fs.querySelectorAll('.va-preis'), function (x) { x.remove(); });
        return;
      }
      z.fs.classList.add('va-zeilen');

      // 09.10.2026 (User-Entscheidung): Aufpreise stehen FEST relativ zur günstigsten
      // Option dieser Gruppe – unabhängig davon, was gerade gewählt ist. Die günstigste
      // Option („Ohne“) trägt kein Label, kein „inklusive“, kein Minusbetrag.
      var kandidaten = z.labels.map(function (label) {
        var wert = normal(beschriftung(label));
        if (!wert) return { label: label, preis: null };
        var ziel = {};
        for (var p in auswahl) ziel[p] = auswahl[p];
        ziel[z.pos] = wert;
        var k = varianteZu(cfg.varianten, ziel);
        return { label: label, preis: k ? k.preis : null };
      });
      var basis = null;
      kandidaten.forEach(function (k) { if (k.preis !== null && (basis === null || k.preis < basis)) basis = k.preis; });

      kandidaten.forEach(function (k) {
        var alt = k.label.querySelector('.va-preis');
        var text = '';
        if (k.preis !== null && basis !== null) {
          var diff = k.preis - basis;
          if (diff > 0) text = '+ ' + geld.format(diff / 100);
        }
        if (alt && alt.textContent === text) return;
        if (alt) alt.remove();
        if (!text) return;
        var span = document.createElement('span');
        span.className = 'va-preis';
        span.textContent = text;
        k.label.appendChild(span);
      });
    });
  }

  function start() {
    anwenden();

    // Sofort neu rechnen, wenn der Kunde umschaltet …
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('fieldset')) {
        window.requestAnimationFrame(anwenden);
      }
    });

    // … und wenn Horizon Teile der Seite austauscht (gedrosselt).
    var wartet = false;
    var beobachter = new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(function () {
        wartet = false;
        anwenden();
      });
    });
    beobachter.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
